import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const UpgradeIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue870'}</MuiIcon>
    );
}
